import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import IconButton from 'atoms/IconButton';
import eventIcons from 'constants/icons';

import { EventOutcomeButtonProps } from './EventOutcomeButtonProps';
import { selectActiveMatchEvents } from '../../features/match/matchSlice';

const EventOutcomeButton: React.FC<EventOutcomeButtonProps> = ({
  matchEventTypeId,
  title,
  onClickCallback,
  disabled,
  selected,
}) => {
  const activeMatchEvents = useSelector(selectActiveMatchEvents);

  let isButtonSelected = false;
  if (selected !== undefined) {
    isButtonSelected = selected;
  } else {
    if (activeMatchEvents) {
      const temp = activeMatchEvents.filter((matchEvent) => matchEvent.matchEventTypeId === matchEventTypeId);
      if (temp.length > 0) {
        isButtonSelected = true;
      }
    }
  }

  const eventIcon: string = eventIcons[matchEventTypeId];

  const onClick = () => {
    if (!isButtonSelected && !disabled) {
      onClickCallback();
    }
  };

  return (
    <IconButton
      icon={eventIcon}
      alt={title}
      className={classNames({
        active: isButtonSelected || selected,
        disabled: disabled,
      })}
      width={100}
      onClick={onClick}
      title={title}
    />
  );
};

export default EventOutcomeButton;
